import React, { useEffect, useState } from 'react';
import {
  getStoredTheme,
  setStoredTheme,
  subscribeToSystemTheme,
} from './theme';

const SunIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M4.9 4.9l1.7 1.7M17.4 17.4l1.7 1.7M19.1 4.9l-1.7 1.7M6.6 17.4l-1.7 1.7" />
  </svg>
);

const MoonIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M20.4 14.2A8.5 8.5 0 0 1 9.8 3.6a8.5 8.5 0 1 0 10.6 10.6z" />
  </svg>
);

/** Theme state: stored preference, else OS; follows OS until a manual pick. */
export function useThemeMode() {
  const [mode, setMode] = useState(() => getStoredTheme());
  useEffect(() => subscribeToSystemTheme(setMode), []);
  const toggle = () =>
    setMode(setStoredTheme(mode === 'dark' ? 'light' : 'dark'));
  return [mode, toggle];
}

/** One-tap light/dark switch — the same control on every screen. */
function ThemeToggle({ className = 'chat-header-toggle' }) {
  const [mode, toggle] = useThemeMode();
  return (
    <button
      type="button"
      className={className}
      onClick={toggle}
      aria-label={
        mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
      }
    >
      {mode === 'dark' ? (
        <SunIcon className="h-5 w-5" />
      ) : (
        <MoonIcon className="h-5 w-5" />
      )}
    </button>
  );
}

export default ThemeToggle;
